/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { Swiper, Navigation, Pagination } from 'swiper/dist/js/swiper.esm.js'
Swiper.use([Navigation, Pagination])

$(function () {
  // initialize pohjaswiper
  const pohjaSwiper = new Swiper('.pohja-swiper-container', {
    watchOverflow: true,
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.pohja-swiper .swiper-button-next',
      prevEl: '.pohja-swiper .swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination.pohjat',
      clickable: true,
      renderBullet: function (index, className) {
        const currentSlide = this.slides[index]
        return '<div class="' + className + '"><span>' + $(currentSlide).data('slide-name') + '</span></div>'
      }
    },
    debugger: true

  })

  // initialize rakenne-swiper
  const rakenneSwiper = new Swiper('.rakenne-swiper-container', {
    watchOverflow: true,
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.rakenne-swiper .swiper-button-next',
      prevEl: '.rakenne-swiper .swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination.rakenne',
      clickable: true,
      renderBullet: function (index, className) {
        const currentSlide = this.slides[index]
        return '<div class="' + className + '"><span>' + $(currentSlide).data('slide-name') + '</span></div>'
      }
    },
    debugger: true

  })

  // show/hide fullscreen swiper when clicking
  $('.swiper.click-large .swiper-slide').on('click', function (event) {
    const container = $(this).parents().find('.swiper.click-large')
    if ($(container).hasClass('fullscreen')) {
      $(container).removeClass('fullscreen')
      $('body').css('overflow-y', 'auto')
    } else {
      $(container).addClass('fullscreen')
      $('body').css('overflow-y', 'hidden')
    }
  })

  // add close button
  $('.swiper.click-large').append('<span class="close-button"></span>')

  // close fullscreen swiper when clicking close-button
  $('.close-button').on('click', function () {
    const container = $(this).parents().find('.swiper.click-large')
    $(container).removeClass('fullscreen')
    $('body').css('overflow-y', 'auto')
  })
})
